export default "__VITE_ASSET__G8oIhi$5__"